module.exports = __webpack_public_path__ + "static/media/Social_Discord_active.f30307fe.svg";